@if (label()) {
    <div class="link-label">
        {{label() | translate: translationParams()}}
    </div>
}
@if (link()) {
    <div class="link-action" woa-touchable woa-activatable
         [ngClass]="{
             'underlined': underlined(),
             'disabled': disabled(),
             'negative': negative(),
             'plain': plain()
         }"
        (onActivate)="activate($event)">
        {{link() | translate: translationParams()}}
    </div>
}
@if (postscript()) {
    <div class="link-postscript">
        {{postscript() | translate: translationParams()}}
    </div>
}
